// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"customizedItems_itemContainer__2LMy6","itemList":"customizedItems_itemList__AUJ_y"};